/* src/app/module/service-provider/add-sp-new-component/subscription-plan/subscription-plan.component.scss */
.subscription-container .custom-header {
  font-size: 1.5rem;
  font-weight: bold;
}
.subscription-container .heading {
  margin-bottom: 23px;
  font-size: 20px;
  font-weight: 600;
}
.subscription-container .subscription-plans {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 16px;
}
.plan-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  width: 31%;
  max-width: 100%;
  margin: 0 auto 16px;
  border: 1px solid #ccc;
  border-radius: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  cursor: pointer;
  transition: border-color 0.3s;
}
.plan-card.selected {
  border: 2px solid #101828;
}
.plan-card .plan-title {
  font-size: 20px;
  font-weight: 600;
  color: #101828;
}
.plan-card .plan-description {
  font-size: 16px;
  text-align: center;
  width: 100%;
  margin-top: 8px;
  color: #475467;
}
.plan-card .plan-price {
  margin-top: 16px;
  font-size: 36px;
  font-weight: bolder;
  color: #101828;
}
.plan-card .plan-features {
  padding-bottom: 40px;
  width: 100%;
}
.plan-card .plan-features .feature {
  display: flex;
  margin-top: 16px;
}
.plan-card .plan-features .feature .feature-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 5px;
}
.plan-card .plan-features .feature .feature-icon.feature-available {
  background-color: #D1FADF;
}
.plan-card .plan-features .feature .feature-icon.feature-available .pi {
  color: #12B76A;
  font-size: 12px;
  font-weight: 800;
}
.plan-card .plan-features .feature .feature-icon.feature-unavailable {
  border: 1.5px solid #F04438;
}
.plan-card .plan-features .feature .feature-icon.feature-unavailable .pi {
  color: #F04438;
  font-size: 12px;
  font-weight: 800;
}
.plan-card .plan-features .feature .feature-text {
  margin-left: 8px;
  color: #475467;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
}
.plan-card .plan-features .feature .feature-text .feature-note {
  font-size: 12px;
  color: #475467;
  margin-top: 4px;
}
.plan-card.recommended {
  position: relative;
}
.plan-card.recommended .recommended-badge {
  position: absolute;
  top: -24px;
  background-color: #FFEAD5;
  color: #FB6514;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
}
.plan-card.recommended .recommended-badge .pi {
  color: #FB6514;
  font-size: 8px;
  margin-right: 4px;
}
.plan-card-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  width: 31%;
  max-width: 100%;
  margin: 0 auto 16px;
  border: 1px solid #FFB255;
  border-radius: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  cursor: pointer;
  transition: border-color 0.3s;
}
.plan-card-2.selected {
  border: 2px solid #101828;
}
.plan-card-2 .plan-title {
  font-size: 20px;
  font-weight: 600;
  color: #101828;
}
.plan-card-2 .plan-description {
  font-size: 16px;
  text-align: center;
  width: 100%;
  margin-top: 8px;
  color: #475467;
}
.plan-card-2 .plan-price {
  margin-top: 16px;
  font-size: 36px;
  font-weight: bolder;
  color: #101828;
}
.plan-card-2 .plan-features {
  padding-bottom: 40px;
  width: 100%;
}
.plan-card-2 .plan-features .feature {
  display: flex;
  margin-top: 16px;
}
.plan-card-2 .plan-features .feature .feature-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 5px;
}
.plan-card-2 .plan-features .feature .feature-icon.feature-available {
  background-color: #D1FADF;
}
.plan-card-2 .plan-features .feature .feature-icon.feature-available .pi {
  color: #12B76A;
  font-size: 12px;
  font-weight: 800;
}
.plan-card-2 .plan-features .feature .feature-icon.feature-unavailable {
  border: 1.5px solid #F04438;
}
.plan-card-2 .plan-features .feature .feature-icon.feature-unavailable .pi {
  color: #F04438;
  font-size: 12px;
  font-weight: 800;
}
.plan-card-2 .plan-features .feature .feature-text {
  margin-left: 8px;
  color: #475467;
  font-size: 16px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
}
.plan-card-2 .plan-features .feature .feature-text .feature-note {
  font-size: 12px;
  color: #475467;
  margin-top: 4px;
}
.plan-card-2.recommended {
  position: relative;
}
.plan-card-2.recommended .recommended-badge {
  position: absolute;
  top: -24px;
  background-color: #FFEAD5;
  color: #FB6514;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
}
.plan-card-2.recommended .recommended-badge .pi {
  color: #FB6514;
  font-size: 8px;
  margin-right: 4px;
}
@media screen and (max-width: 600px) {
  .plan-card {
    max-width: 450px;
    margin: 0 16px 16px;
    padding: 24px;
  }
}
button.btn.btn-primary {
  background-color: #FF8C00;
  border-color: #FF8C00;
  border: 1px solid #FF8C00;
  padding: 10px 15px;
  border-radius: 5px;
  color: #fff;
  margin-top: 43px;
  font-size: 16px;
  font-weight: 600;
}
button.btn.btn-primary:hover {
  background-color: #e65c00;
  border-color: #e65c00;
  border: 1px solid #e65c00;
}
form {
  width: 100%;
}
/*# sourceMappingURL=subscription-plan.component-OKSMA52R.css.map */
